import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/share_profile_screen.jpeg")